import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Servicios
import { UserService } from '../../services/api';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import DJDUV from './DJDUV';
// import DJDUVPrint from '../DJDUVPrint/DJDUVPrint';

//Estilos

function DJCPContainer() {
    const { token, masters, grapesVariety, settings, formatNumber } =
        useGlobalContext();

    const [loader, setLoader] = useState(false);
    const [print, setPrint] = useState(false);
    const [WatchDJDUVLogs, setWatchDJDUVLogs] = useState(false);
    const [DJDUVData, setDJDUVData] = useState({});

    const Params = useParams();

    useEffect(() => {
        // const getMyDJDUV = async () => {
        //     try {
        //         setLoader(true);
        //         //Obtenemos la DJDUV segun el id que esta en los params
        //         const MyDJDUVs = await DJDUVService.single({
        //             token,
        //             id: parseInt(Params.id),
        //         });
        //         //Si la respuesta es correcta seteamos el estado de MyDJDUV con los datos de la respuesta
        //         if (MyDJDUVs) {
        //             const getNombreUsuario = await UserService.getNombreUsuario(
        //                 { token, usuarioId: MyDJDUVs.data.cabecera.usuario }
        //             );
        //             if (getNombreUsuario) {
        //                 setDJDUVData({
        //                     ...MyDJDUVs.data,
        //                     ...getNombreUsuario.data,
        //                 });
        //             }
        //         }
        //         setLoader(false);
        //     } catch (err) {
        //         setLoader(false);
        //         return err;
        //     }
        // };
        // getMyDJDUV();
    }, [Params.id]);

    return loader ? (
        <Spinner />
    ) : (
        <>
            <DJDUV
                functions={{
                    formatNumber,
                    setPrint,
                    setWatchDJDUVLogs,
                }}
                states={{ WatchDJDUVLogs, DJDUVData, masters }}
            />
            {/* <DJDUVPrint
                functions={{
                    formatNumber,
                    setPrint,
                }}
                states={{
                    DJDUVData,
                    masters,
                    grapesVariety,
                    settings,
                }}
            /> */}
        </>
    );
}

export default DJCPContainer;
